import React, { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import {
    getShareHolders,
    deleteShareHolder,
    updateShareHolder,
    createShareList
} from "../../../Utility/Api";
import { Deletemodel } from "../../Common/Functions";
import AddShareHolderForm from "./form/AddShareHolderForm";
import { WarehouseContext } from "../../../Utility/UserContext";

const ShareHolderList = () => {
    const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);

    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [modalType, setModalType] = useState("");
    const [selectedData, setSelectedData] = useState(null);
    const [paymentModal, setPaymentModal] = useState(false);
    const [selectedID, setSelectedID] = useState(null);
    const [paymentData, setPaymentData] = useState({
        total_profit: "",
        distributed_amount: "",
        // remarks: "",
    });
    const [shareResult, setShareResult] = useState(null);



    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        showLoader();
        try {
            const params = {
                shop_id: shopItem?.shop_id || "",
            };
            const res = await getShareHolders(params);
            setData(res?.data?.data || []);
        } catch {
            toast.error("Failed to load shareholders");
        } finally {
            hideLoader();
        }
    };


    const openAddEditModal = (row = null) => {
        setSelectedData(row);
        setShowModal(true);
    };

    const openStatusModal = (id) => {
        setSelectedID(id);
        setModalType("status");
        setConfirmModal(true);
    };

    const openDeleteModal = (id) => {
        setSelectedID(id);
        setModalType("delete");
        setConfirmModal(true);
    };


    const handleStatusToggle = async () => {
        try {
            showLoader();
            const current = data.find(i => i.id === selectedID);
            const newStatus = current.status === "0" ? "1" : "0";

            await updateShareHolder(selectedID, {
                ...current,
                status: newStatus,
            });

            toast.success("Status updated");
            fetchData();
        } catch {
            toast.error("Failed to update status");
        } finally {
            hideLoader();
            setConfirmModal(false);
        }
    };


    const handleDelete = async () => {
        try {
            showLoader();
            await deleteShareHolder(selectedID);
            toast.success("Shareholder deleted");
            fetchData();
        } catch {
            toast.error("Delete failed");
        } finally {
            hideLoader();
            setConfirmModal(false);
        }
    };

    // const openPaymentModal = (shareholder) => {
    //     setSelectedData(shareholder);
    //     setPaymentModal(true);
    // };
    const openPaymentModal = () => {
        setSelectedData();
        setPaymentModal(true);
    };

    const handlePaymentSubmit1 = async () => {
        try {
            if (!paymentData.total_profit || !paymentData.distributed_amount) {
                toast.error("Please fill all required fields");
                return;
            }

            showLoader();
            const payload = {
                parent_id: selectedData.id,
                total_profit: paymentData.total_profit,
                distributed_amount: paymentData.distributed_amount,
                shop_id: shopItem?.shop_id || "",
                created_by: UserItem?.id || "1",
                remarks: paymentData.remarks || "",
            };

            await createShareList(payload);
            toast.success("Payment recorded successfully");
            setPaymentModal(false);
            setPaymentData({
                total_profit: "",
                distributed_amount: "",
                remarks: "",
            });
        } catch (error) {
            toast.error(error?.message || "Failed to record payment");
        } finally {
            hideLoader();
        }
    };
    const handlePaymentSubmit = async () => {
        try {
            if (!paymentData.total_profit || !paymentData.distributed_amount) {
                toast.error("Please fill all required fields");
                return;
            }

            if (parseFloat(paymentData.distributed_amount) > parseFloat(paymentData.total_profit)) {
                toast.error("Distributed amount cannot exceed total profit");
                return;
            }

            showLoader();

            const payload = {
                // parent_id: selectedData.id,
                total_profit: paymentData.total_profit,
                distributed_amount: paymentData.distributed_amount,
                shop_id: shopItem?.shop_id || "",
                created_by: UserItem?.id || "1",
                // remarks: paymentData.remarks || "",
            };

            const res = await createShareList(payload);
            if (res?.data?.status === "success") {
                setShareResult(res.data);
                toast.success("Payment recorded successfully");
            }
            setPaymentModal(false);
            setPaymentData({
                total_profit: "",
                distributed_amount: "",
                // remarks: "",
            });
        } catch (error) {
            const backendMsg =
                error?.response?.data?.message || "Failed to record payment";

            const required = error?.response?.data?.required_amount;
            const available = error?.response?.data?.available_balance;

            if (required && available) {
                toast.error(
                    `${backendMsg}. Required ₹${required}, Available ₹${available}`
                );
            } else {
                toast.error(backendMsg);
            }

        } finally {
            hideLoader();
        }
    };



    const parents = data.filter(i => !i.parent_id);
    const children = data.filter(i => i.parent_id);

    return (
        <div className="page-content">
            {/* HEADER */}
            <div className="d-flex justify-content-start align-items-end">
                <h5 className="text-uppercase ">Share Holders</h5>
                </div>
                <div className="d-flex justify-content-end align-items-end gap-2 mb-2">
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => openAddEditModal()}
                >
                    {/* <i className="bi bi-plus-circle me-1"></i> */}
                    Add Share Holder
                </button>
                <button
                    type="button"
                    className="btn btn-sm btn-warning  me-2 px-4"
                    onClick={() => openPaymentModal()}
                    disabled={!data || data.length === 0}

                >
                    {/* <i className="bi bi-cash-coin"></i> */}
                    Pay
                </button>
            </div>

            {/* TABLE */}
            <div className="card shadow-sm">
                <div className="card-body table-responsive">
                    <table className="table table-bordered table-hover align-middle mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Equity</th>
                                <th>Capital</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {parents.length === 0 && (
                                <tr>
                                    <td colSpan="8" className="text-center text-muted">
                                        No shareholders found
                                    </td>
                                </tr>
                            )}

                            {parents.map((parent, pIndex) => (
                                <React.Fragment key={parent.id}>
                                    {/* ================= PARENT ROW ================= */}
                                    <tr className="table-primary fw-semibold">
                                        <td>{pIndex + 1}</td>

                                        <td>
                                            <div className="d-flex align-items-center gap-2">
                                                <i className="bi bi-person-badge"></i>
                                                {parent.name}
                                            </div>
                                        </td>

                                        <td>{parent.phone}</td>

                                        <td>
                                            <span className="badge bg-info">
                                                {parent.equity}%
                                            </span>
                                        </td>

                                        <td>
                                            <strong>
                                                ₹ {parent.capital || "-"}
                                            </strong>
                                        </td>

                                        <td>
                                            <span className="badge bg-primary">
                                                Parent
                                            </span>
                                        </td>

                                        <td>
                                            <button
                                                className={`btn btn-sm ${parent.status === "0"
                                                    ? "btn-success"
                                                    : "btn-outline-secondary"
                                                    }`}
                                                onClick={() =>
                                                    openStatusModal(parent.id)
                                                }
                                            >
                                                {parent.status === "0"
                                                    ? "Active"
                                                    : "Inactive"}
                                            </button>
                                        </td>

                                        <td className="text-center">
                                            <img
                                                src='/assets/images/icons/edit.png'
                                                onClick={() => openAddEditModal(parent)}
                                                height={"20px"}
                                                alt="Edit"
                                                className='mx-2'
                                            />
                                            {/* <button
                                                className="btn btn-sm btn-light rounded-circle  align-items-center justify-content-center"
                                                onClick={() => openPaymentModal(parent)}
                                                style={{ width: '35px', height: '35px' }}
                                                title="Make Payment"
                                            >
                                                <i className="bi bi-cash-coin text-success"></i>
                                            </button> */}
                                            <img
                                                src='/assets/images/icons/delete.png'
                                                onClick={() => openDeleteModal(parent.id)}
                                                height={"20px"}
                                                alt="Delete"
                                                className='mx-2'
                                            />
                                            {/* <button
                                                type="button"
                                                className="btn btn-sm btn-warning  align-items-center gap-2"
                                                onClick={() => openPaymentModal(parent)}
                                            >
                                                // <i className="bi bi-cash-coin"></i> 
                                                Pay
                                            </button> */}



                                        </td>
                                    </tr>

                                    {children
                                        .filter(
                                            c =>
                                                String(c.parent_id) ===
                                                String(parent.id)
                                        )
                                        .map((child) => (
                                            <tr key={child.id}>
                                                <td className="text-muted">—</td>

                                                <td className="ps-4 text-muted">
                                                    <span className="me-2">↳</span>
                                                    {child.name}
                                                </td>

                                                <td className="text-muted">
                                                    {child.phone}
                                                </td>

                                                <td>
                                                    <span className="badge bg-light text-dark">
                                                        {child.equity}%
                                                    </span>
                                                </td>

                                                <td className="text-muted">{child.capital}</td>

                                                <td>
                                                    <span className="badge bg-secondary">
                                                        Child
                                                    </span>
                                                </td>

                                                <td>
                                                    <button
                                                        className={`btn btn-sm ${child.status === "0"
                                                            ? "btn-success"
                                                            : "btn-outline-secondary"
                                                            }`}
                                                        onClick={() =>
                                                            openStatusModal(
                                                                child.id
                                                            )
                                                        }
                                                    >
                                                        {child.status === "0"
                                                            ? "Active"
                                                            : "Inactive"}
                                                    </button>
                                                </td>

                                                <td className="text-center">
                                                    {/* <i
                                                        className="bi bi-pencil-square text-primary me-2"
                                                        role="button"
                                                        onClick={() =>
                                                            openAddEditModal(
                                                                child
                                                            )
                                                        }
                                                    ></i>
                                                    <i
                                                        className="bi bi-trash text-danger"
                                                        role="button"
                                                        onClick={() =>
                                                            openDeleteModal(
                                                                child.id
                                                            )
                                                        }
                                                    ></i> */}
                                                    <img
                                                        src='/assets/images/icons/edit.png'
                                                        onClick={() => openAddEditModal(child)}
                                                        height={"15px"}
                                                        alt="Edit"
                                                        className='mx-2'
                                                    />
                                                    <img
                                                        src='/assets/images/icons/delete.png'
                                                        onClick={() => openDeleteModal(child.id)}
                                                        height={"15px"}
                                                        alt="Delete"
                                                        className='mx-2'
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* CONFIRM MODAL */}
            {confirmModal && (
                <Deletemodel
                    setShowModal={setConfirmModal}
                    handleDelete={
                        modalType === "status"
                            ? handleStatusToggle
                            : handleDelete
                    }
                    text={
                        modalType === "status"
                            ? "Change status of shareholder?"
                            : "Delete this shareholder?"
                    }
                />
            )}

            {paymentModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content" style={{ borderRadius: '12px' }}>
                            <div className="modal-header border-0 pb-0">
                                <div>
                                    <h5 className="modal-title fw-bold">
                                        <i className="bi bi-cash-stack me-2 text-success"></i>
                                        Payment Record
                                    </h5>
                                    <p className="text-muted mb-0 small">
                                        Recording payment for: <strong>{selectedData?.name ? selectedData.name :"All ShareHolder Distribution" }</strong>
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setPaymentModal(false);
                                        setPaymentData({
                                            total_profit: "",
                                            distributed_amount: "",
                                            remarks: "",
                                        });
                                    }}
                                />
                            </div>
                            <div className="modal-body p-4">
                                <div className="mb-3">
                                    <label className="form-label small text-muted">
                                        <i className="bi bi-currency-rupee me-1"></i>
                                        Total Profit <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control form-control-lg"
                                        placeholder="Enter total profit amount"
                                        value={paymentData.total_profit}
                                        onChange={(e) => setPaymentData({
                                            ...paymentData,
                                            total_profit: e.target.value
                                        })}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label small text-muted">
                                        <i className="bi bi-cash me-1"></i>
                                        Distributed Amount <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control form-control-lg"
                                        placeholder="Enter amount to distribute"
                                        value={paymentData.distributed_amount}
                                        onChange={(e) => setPaymentData({
                                            ...paymentData,
                                            distributed_amount: e.target.value
                                        })}
                                    />
                                    {selectedData?.equity && paymentData.distributed_amount && (
                                        <small className="text-muted mt-1 d-block">
                                            {selectedData.name}'s share ({selectedData.equity}%):
                                            <strong> ₹{(paymentData.distributed_amount * selectedData.equity / 100).toFixed(2)}</strong>
                                        </small>
                                    )}
                                </div>
                                {/* <div className="mb-3">
                                    <label className="form-label small text-muted">
                                        <i className="bi bi-chat-left-text me-1"></i>
                                        Remarks
                                    </label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        placeholder="Add any notes or remarks..."
                                        value={paymentData.remarks}
                                        onChange={(e) => setPaymentData({
                                            ...paymentData,
                                            remarks: e.target.value
                                        })}
                                    />
                                </div> */}
                            </div>
                            <div className="modal-footer border-0 pt-0">
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    onClick={() => {
                                        setPaymentModal(false);
                                        setPaymentData({
                                            total_profit: "",
                                            distributed_amount: "",
                                            remarks: "",
                                        });
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success d-flex align-items-center gap-2"
                                    onClick={handlePaymentSubmit}
                                >
                                    {/* <i className="bi bi-check-circle"></i> */}
                                    Payment
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ADD / EDIT MODAL */}
            {showModal && (
                <AddShareHolderForm
                    data={selectedData}
                    closeModal={() => setShowModal(false)}
                    refreshList={fetchData}
                />
            )}
        </div>
    );
};

export default ShareHolderList;


